import React from 'react';
import { Link } from 'react-router-dom';

export default function RixinCTA() {
  return (
    <section className="bg-primary-500 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-6">
            <i className="ri-ship-line text-sm w-4 h-4 flex items-center justify-center" />
            Importación Directa China → Venezuela
          </div>

          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-6 leading-tight">
            RESINVENCA RESINAS DE VENEZUELA C.A. es el Vendedor Oficial en Venezuela
            <span className="block mt-2 text-xl md:text-2xl opacity-90">
              de los Demulsificantes Ya Terminados de Rixin Group
            </span>
          </h2>

          <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-10 max-w-2xl mx-auto">
            Importamos directamente desde las plantas de Rixin Group en China. El producto llega a Venezuela
            formulado, certificado y empacado. No requiere procesos adicionales ni diluciones: listo para aplicar
            en sus campos petroleros desde el primer día.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contacto"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
            >
              Solicitar Cotización Ahora
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/productos"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Ver Producto Demulsificante
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-background-50/60 text-xs">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line" />
              Producto ya formulado
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-ship-line" />
              Importación directa China
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-map-pin-line" />
              Puesto en Venezuela
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}